"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PgumosruIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("../../SvgIcon"));

var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M20,0V20M0,20V0M3,1.5v13A1.5,1.5,0,0,0,4.5,16H6.88a1,1,0,0,0,.72-.31,9.05,9.05,0,0,1,1.52-1.24A.25.25,0,0,0,9,14H5V3H15V14H14a8.05,8.05,0,0,0-5.73,2.42,1,1,0,0,0-.27.7v2.13a.25.25,0,0,0,.45.15l.75-1A6,6,0,0,1,14,16h1.5A1.5,1.5,0,0,0,17,14.5V1.5a.5.5,0,0,0-.5-.5H3.5A.5.5,0,0,0,3,1.5Z"
});

function PgumosruIcon(props) {
  return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 20 20"
  }, props), _ref);
}

PgumosruIcon.displayName = 'PgumosruIcon';
PgumosruIcon.defaultProps = {
  color: '#c92723'
};